import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import { SOCIAL_LINKS } from '../../config/externalLinks';
import logo from '../../assets/logo.jpg';
import './footer.scss';

const Footer = () => {
  const { pathname } = useLocation();
  const { content } = useTranslation();
  const c = content.footer;
  const year = new Date().getFullYear();
  const socialLinks = SOCIAL_LINKS;

  return (
    <footer className="site-footer" id="contact">
      <div className="parent-bg site-footer__band">
        <div className="container site-footer__inner">
          <div className="site-footer__main">
            <div className="site-footer__lead">
              <Link
                to="/"
                className="site-footer__brand"
                aria-label={content.header.brandAria}
                onClick={() => {
                  if (pathname === '/') window.scrollTo(0, 0);
                }}
              >
                <img src={logo} alt="HumPro logo" className="site-footer__logo" />
              </Link>
              <p className="site-footer__tagline">{c.tagline}</p>
            </div>

            <nav className="site-footer__nav" aria-label="Footer navigation">
              <div className="site-footer__nav-block">
                <p className="site-footer__nav-label" id="footer-nav-site">
                  {c.navSite}
                </p>
                <ul className="site-footer__list" aria-labelledby="footer-nav-site">
                  <li>
                    <Link
                      to="/"
                      onClick={() => {
                        if (pathname === '/') window.scrollTo(0, 0);
                      }}
                    >
                      {c.navHome}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about">{c.navAbout}</Link>
                  </li>
                  <li>
                    <Link to="/courses">{c.navCourses}</Link>
                  </li>
                </ul>
              </div>
              <div className="site-footer__nav-block">
                <p className="site-footer__nav-label" id="footer-nav-more">
                  {c.navMore}
                </p>
                <ul className="site-footer__list" aria-labelledby="footer-nav-more">
                  <li>
                    <Link to="/consultancy">{c.navConsultancy}</Link>
                  </li>
                  <li>
                    <Link to="/careers">{c.navCareers}</Link>
                  </li>
                  <li>
                    <Link to="/contact">{c.navContact}</Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div className="site-footer__rule" role="presentation" />

          <div className="site-footer__meta">
            <div className="site-footer__socials">
              <a
                href={socialLinks.linkedin}
                className="site-footer__social"
                aria-label={c.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.11 1 2.48 1 4.98 2.12 4.98 3.5zM.5 8h4V23h-4V8zm7 0h3.8v2h.1c.53-1 1.84-2.2 3.79-2.2 4.05 0 4.8 2.67 4.8 6.13V23h-4v-7.1c0-1.7-.03-3.9-2.38-3.9-2.38 0-2.74 1.86-2.74 3.78V23h-4V8z"
                  />
                </svg>
              </a>
              <a
                href={socialLinks.youtube}
                className="site-footer__social"
                aria-label={c.youtube}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    d="M23.5 6.2a3 3 0 00-2.1-2.1C19.4 3.5 12 3.5 12 3.5s-7.4 0-9.4.6A3 3 0 00.5 6.2C0 8.2 0 12 0 12s0 3.8.5 5.8a3 3 0 002.1 2.1c2 .6 9.4.6 9.4.6s7.4 0 9.4-.6a3 3 0 002.1-2.1c.5-2 .5-5.8.5-5.8s0-3.8-.5-5.8zM9.6 15.6V8.4L15.8 12l-6.2 3.6z"
                  />
                </svg>
              </a>
              <a
                href={socialLinks.instagram}
                className="site-footer__social"
                aria-label={c.instagram}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    d="M7.8 2h8.4A5.8 5.8 0 0122 7.8v8.4a5.8 5.8 0 01-5.8 5.8H7.8A5.8 5.8 0 012 16.2V7.8A5.8 5.8 0 017.8 2zm-.2 2A3.6 3.6 0 004 7.6v8.8A3.6 3.6 0 007.6 20h8.8a3.6 3.6 0 003.6-3.6V7.6A3.6 3.6 0 0016.4 4H7.6zm9.65 1.5a1.35 1.35 0 110 2.7 1.35 1.35 0 010-2.7zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z"
                  />
                </svg>
              </a>
              <a
                href={socialLinks.facebook}
                className="site-footer__social"
                aria-label={c.facebook}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    d="M13.5 8H16V5h-2.5C10.5 5 9 6.8 9 9.6V12H6v3h3v7h3v-7h3l.5-3H12V9.8c0-1 .3-1.8 1.5-1.8z"
                  />
                </svg>
              </a>
            </div>

            <div className="site-footer__policies">
              <Link to="/privacy">{c.privacy}</Link>
              <span className="site-footer__dot" aria-hidden="true">
                ·
              </span>
              <Link to="/terms">{c.terms}</Link>
            </div>

            <p className="site-footer__copy">
              © {year} {c.rightsSuffix}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
